import baseConfig from "./baseconfig.json";

const host = window.location.protocol + "//" + window.location.host;

const domainMapping = baseConfig.domainMapping;

const currentFlavor =
  Object.keys(domainMapping).find((key) =>
    domainMapping[key].some((domain) => host.includes(domain))
  ) || "default";

// const currentFlavor = "nodeui";

const selectedConfig = baseConfig.flavors[currentFlavor] || {};
// console.log(currentFlavor);

const conf = {
  ...baseConfig.common,
  ...selectedConfig,
  fleetURL: selectedConfig.url + "public/fleet",
  // fleetURL1: selectedConfig.imgurl + "public/fleet",

  baseURL: selectedConfig.url + "/app/",
  fleetURLAdvertise: selectedConfig.url + "/public/fleet/",
  // NodeCoreUrl: "https://dolphin.trackeazy.com",
  // NodeCoreUrl: "https://sa.trackeazy.com/api2",
  NodeUrl: selectedConfig.NodeCoreUrl,

  reportUrl: "http://172.31.43.85:5000/",
  reportUrl2: "https://dolphin.trackeazy.com",
  reportUrl3: "https://www.awtltrack.com/",
  // NodeCoreUrl: "http://localhost:3056",
  excelUrl: "http://localhost:3076",
  pythonReportlUrl: "http://13.126.174.243/pmistrackreact/api",
  currentFlavor: currentFlavor,
  pythonReport: 1,
};

export default conf;
